// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--z-index-filter-panel: 1;
	--z-index-profile-panel: 3;
}`, "",{"version":3,"sources":["webpack://./src/Theme/ZIndex/z-index.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B","sourcesContent":[":root {\r\n\t--z-index-filter-panel: 1;\r\n\t--z-index-profile-panel: 3;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
